export function formatWeightThickness(abbrev: string, thicknessMM: number | null): string {
  return thicknessMM == null ? abbrev : `${abbrev} (${thicknessMM}mm thick)`;
}
